import { Leaf, Fish, ShoppingBasket, Beef } from 'lucide-react';
import { smoothScrollToSection } from '@/lib/utils';

const categories = [
  {
    id: 'produce',
    label: 'Produce',
    chineseLabel: '蔬果',
    Icon: Leaf,
    colors: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'
  },
  {
    id: 'meat-section',
    label: 'Meat',
    chineseLabel: '肉類',
    Icon: Beef,
    colors: 'bg-red-100 text-red-700 hover:bg-red-200'
  },
  {
    id: 'seafood',
    label: 'Seafood',
    chineseLabel: '海鮮',
    Icon: Fish,
    colors: 'bg-blue-100 text-blue-700 hover:bg-blue-200'
  },
  {
    id: 'groceries',
    label: 'Groceries',
    chineseLabel: '雜貨',
    Icon: ShoppingBasket,
    colors: 'bg-amber-100 text-amber-700 hover:bg-amber-200'
  },
];

export function CategoryNav() {
  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 py-3">
        <div className="flex justify-center gap-2 md:gap-4">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => smoothScrollToSection(cat.id)}
              className={`flex items-center gap-2 px-3 md:px-5 py-2.5 rounded-lg font-medium group transition-colors ${cat.colors}`}
            >
              <cat.Icon className="w-5 h-5 group-hover:scale-110 transition-transform" />
              <span className="hidden sm:inline">{cat.label}</span>
              <span className="text-xs opacity-70 hidden md:inline">{cat.chineseLabel}</span>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
